import SIDES from "../../apps/invoicesSides";

export default function SideToggle({ side, onChange }) {
   return (
      <div className="btn-group" role="group" aria-label="Invoice side">
         {Object.values(SIDES).map((s) => (
            <button
               key={s.key}
               type="button"
               className={`btn ${side === s.key ? "btn-primary" : "btn-outline-secondary"}`}
               onClick={() => onChange(s.key)}>
               {s.label}
            </button>
         ))}
      </div>
   );
}
